<template>
  <div class="row">
    <div v-if="producer" class="col-sm-6 col-xs-12">
      <div>
        <label class="control-label font-weight-bold mr-2">PRODUCTOR: </label>
        <span>{{ producer.businessName }}</span>
      </div>
      <div>
        <label class="control-label font-weight-bold mr-2">CUIT: </label>
        <span>{{ producer.cuit }}</span>
      </div>
      <div v-if="producer.distributor">
        <label class="control-label font-weight-bold mr-2">DISTRIBUIDOR: </label>
        <span>{{ producer.distributor.name }}</span>
      </div>
      <div v-if="producer.distributor.seller">
        <label class="control-label font-weight-bold mr-2">ASESOR TÉCNICO: </label>
        <span>{{ producer.distributor.seller.name }}</span>
      </div>
    </div>

    <div class="col-sm-5 offset-sm-1 col-xs-12">
      <div v-if="orderNumber">
        <label class="control-label font-weight-bold mr-2">NÚMERO PEDIDO: </label>
        <span>{{ orderNumber }}</span>
      </div>
      <div>
        <label class="control-label font-weight-bold mr-2">FECHA: </label>
        <span>{{ orderDate | date('DD/MM/YYYY') }}</span>
      </div>
      <div v-if="campaign">
        <label class="control-label font-weight-bold mr-2">CAMPAÑA: </label>
        <span>{{ campaign.name }}</span>
      </div>
      <div v-if="user">
        <label class="control-label font-weight-bold mr-2">SOLICITANTE: </label>
        <span>{{ user.name }}</span>
      </div>
      <div v-if="projection">
        <label class="control-label font-weight-bold mr-2">PROYECCION ASOCIADA: </label>
        <span>
          <router-link v-if="projection.id" :to="{ name: 'ProjectionShow', params: { id: projection.id } }">
            Ver proyeccion asociada
          </router-link>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    producer: {
      type: Object,
      required: true,
    },

    campaign: {
      type: Object,
      required: true,
    },

    orderDate: {
      type: [Date, String],
      required: true,
    },

    orderNumber: {
      type: String,
      default: null,
    },

    user: {
      type: Object,
      default: () => null,
    },

    projection: {
      type: Object,
      default: null,
    },
  },
};
</script>
